var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('HeadNav'),(_vm.layout == 'LayoutDefault')?_c('LeftNav'):_vm._e(),_c('v-main',[_c('v-container',{staticClass:"main-container",attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('FooterNav'),_c('Alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }